// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"279":"18c2b2be","706":"f2a2e38a","941":"1f172401"}[chunkId] + ".js";
};